var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { margin: "20px" } },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "140px" } },
        [
          _c("el-form-item", { attrs: { label: "手机号" } }, [
            _vm._v(" " + _vm._s(_vm.post.mobile || "-") + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "会员卡号" } }, [
            _vm._v(" " + _vm._s(_vm.post.cardNo || "-") + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "任务名称" } }, [
            _vm._v(" " + _vm._s(_vm.post.taskName || "-") + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "帖子类型" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.post.userType == 1
                    ? "员工"
                    : _vm.post.userType == 2
                    ? "用户"
                    : "全部"
                ) +
                " "
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "帖子内容" } }, [
            _vm.post.postContent
              ? _c("div", {
                  staticClass: "post-content",
                  staticStyle: { "white-space": "pre-wrap" },
                  domProps: { innerHTML: _vm._s(_vm.postContentHtml) },
                })
              : _c("div", [_vm._v("-")]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内容字数" } }, [
            _vm._v(" " + _vm._s(_vm.post.contentLength || "-") + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "关键词" } }, [
            _vm._v(" " + _vm._s(_vm.post.keywords || "-") + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "关键词匹配数量" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.post.keywordMatchCount ||
                    _vm.post.keyword_match_count ||
                    "-"
                ) +
                " "
            ),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "图片列表" } }, [
            _vm.imgList.length
              ? _c(
                  "div",
                  { staticClass: "subImg" },
                  _vm._l(_vm.imgList, function (url, idx) {
                    return _c("img", {
                      key: idx,
                      attrs: { src: url, alt: "img" },
                      on: {
                        click: function ($event) {
                          return _vm.previewImg(idx)
                        },
                      },
                    })
                  }),
                  0
                )
              : _c("div", [_vm._v("-")]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "订单图片列表" } }, [
            _vm.orderImgList.length
              ? _c(
                  "div",
                  { staticClass: "subImg" },
                  _vm._l(_vm.orderImgList, function (url, idx) {
                    return _c("img", {
                      key: idx,
                      attrs: { src: url, alt: "img" },
                      on: {
                        click: function ($event) {
                          return _vm.previewOrderImg(idx)
                        },
                      },
                    })
                  }),
                  0
                )
              : _c("div", [_vm._v("-")]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "帖子状态" } }, [
            _vm._v(" " + _vm._s(_vm.statusText) + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "是否优质" } }, [
            _vm._v(" " + _vm._s(_vm.post.isQuality ? "是" : "否") + " "),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "问题/答案" } }, [
            _vm.questionsAnswers
              ? _c(
                  "div",
                  _vm._l(_vm.questionsAnswers, function (item) {
                    return _c("div", [
                      _vm._v(
                        _vm._s(item.question) + "：" + _vm._s(item.answer)
                      ),
                    ])
                  }),
                  0
                )
              : _c("div", [_vm._v("-")]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "图片检测内容" } }, [
            _vm.post.imgContent
              ? _c("div", [_vm._v(_vm._s(_vm.formatJson(_vm.post.imgContent)))])
              : _c("div", [_vm._v("-")]),
          ]),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "收货地址" } }, [
            _vm._v(
              " " +
                _vm._s(_vm.post.consignee || "") +
                " " +
                _vm._s(_vm.post.consigneePhone || "") +
                " " +
                _vm._s(_vm.post.address || "-") +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          ref: "previewDialog",
          attrs: {
            "close-on-click-modal": "true",
            visible: _vm.previewVisible,
            modal: false,
            "append-to-body": "",
            width: "80%",
            top: "6vh",
            "custom-class": "img-preview-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("img", {
              staticStyle: { "max-width": "100%", "max-height": "80vh" },
              attrs: { src: _vm.previewList[_vm.previewIndex] },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "text-align": "center", "margin-top": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", disabled: _vm.previewIndex === 0 },
                  on: { click: _vm.prevImg },
                },
                [_vm._v("上一张")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    disabled: _vm.previewIndex === _vm.previewList.length - 1,
                  },
                  on: { click: _vm.nextImg },
                },
                [_vm._v("下一张")]
              ),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "10px" } }, [
                _vm._v(
                  _vm._s(_vm.previewIndex + 1) +
                    "/" +
                    _vm._s(_vm.previewList.length)
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }